// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-view {
  position: fixed;
  left: 440px;
  top: 70px;
  bottom: 50px;
  right: 0;
  z-index: 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  border-top: 3px solid #ffffff;
  border-radius: 10px;
  width: 430px;
  background-color: #fff;
}
.main-view .ScrollbarsCustom-Content:has(.monitoring-unit-panel) {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
.main-view img {
  max-width: 100%;
  height: auto;
}
.main-view.no-sidebar {
  top: 50px;
  width: 51%;
  left: 106px;
  margin-top: 25px;
}

.montoringBoxes {
  display: "flex";
  justify-content: "center";
}

.mt-0 {
  margin-top: 0;
}

.mb-0 {
  margin-bottom: 0;
}

.ml-0 {
  margin-left: 0;
}

.mr-0 {
  margin-right: 0;
}

.navbar-menu-item .counter {
  left: auto;
  right: -0.3em;
  top: -0.5em;
}

.no-sidebar {
  left: 50px;
}

.has-padding {
  padding: 12px;
}

.async-select {
  color: #000;
}

.visible-responsive {
  display: none !important;
}

.recharts-default-tooltip {
  background: #fff;
  color: #222;
  min-width: 150px;
  padding: 10px;
  border-radius: 4px;
}

.full-height-container {
  height: 100vh;
  min-height: 100%;
}

.leaflet-container.chat-map-container {
  height: 100%;
  min-height: inherit;
}

.ticker__element .ticker-inner {
  display: flex;
  white-space: nowrap;
  padding-left: 100px;
}

.MuiListSubheader-root {
  line-height: 30px !important;
  border-top: 1px solid;
}

@media (max-width: 959px) {
  .header-open .main-view,
  .no-sidebar .main-view,
  .sidebar-collapse .main-view {
    left: 0;
  }
  .fms-sidebar-wrapper,
  .fms-sidebar-wrapper .fms-sidebar {
    width: 320px;
    left: -320px;
  }
  .sidebar-dragicon {
    display: none;
  }
  .sidebar-collapse .sidebar-dragicon {
    display: block;
  }
  .sidebar-collapse .fms-sidebar-wrapper,
  .sidebar-collapse .fms-sidebar-wrapper .fms-sidebar {
    left: 0;
  }
  .sidebar-devices-list,
  .scrollable-sidebar {
    margin-right: 0;
  }
  .fms-header,
  .main-view {
    left: 0;
  }
  .left-nav {
    width: 50px;
    left: -50px;
  }
  .header-open .left-nav {
    left: 0;
  }
  .navbar-menu .navbar-menu-item {
    display: block;
  }
  .nav-link-text {
    display: inline-block;
  }
  .hidden-responsive {
    display: none !important;
  }
  .visible-responsive {
    display: block !important;
  }
}
@media (max-width: 888px) {
  .header-open .main-view,
  .no-sidebar .main-view,
  .sidebar-collapse .main-view {
    left: 0;
  }
  .fms-sidebar-wrapper {
    bottom: 0;
    background: #fff;
  }
  .fms-sidebar-wrapper,
  .fms-sidebar {
    box-sizing: border-box;
    background: #fff;
  }
  .sidebar-dragicon {
    display: none;
  }
  .sidebar-collapse .sidebar-dragicon {
    display: block;
  }
  .main-view {
    box-sizing: border-box;
    background: #fff;
    z-index: 0;
  }
  .main-view .main-view {
    top: 0;
    bottom: 0;
    overflow: auto;
  }
  .daterangepicker .drp-selected {
    padding-right: 0;
  }
  .daterangepicker .ranges,
  .daterangepicker .drp-calendar {
    float: none;
  }
  .daterangepicker .ranges ul {
    width: auto;
  }
  .ScrollbarsCustom-Wrapper {
    right: 0 !important;
  }
}
@media (max-width: 499px) {
  .main-view {
    bottom: 28px;
  }
  .has-padding {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EAEA,QAAA;EACA,UAAA;EACA,uCAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAFF;AAIE;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,sBAAA;AAFJ;AAIE;EACE,eAAA;EACA,YAAA;AAFJ;AAIE;EACE,SCRgB;EDShB,UAAA;EACA,WAAA;EACA,gBAAA;AAFJ;;AAKA;EACE,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE,cAAA;AAAF;;AAEA;EACE,eAAA;AACF;;AAQA;EACE,UAAA;EACA,aAAA;EACA,WAAA;AALF;;AAQA;EACE,UC5Ce;ADuCjB;;AAOA;EAEE,aAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,gBAAA;AAJF;;AAMA;EACE,YAAA;EACA,mBAAA;AAHF;;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,4BAAA;EACA,qBAAA;AAJF;;AASA;EACE;;;IAGE,OAAA;EANF;EAQA;;IAEE,YCpGY;IDqGZ,YAAA;EANF;EAQA;IACE,aAAA;EANF;EAQA;IACE,cAAA;EANF;EASE;;IAEE,OAAA;EAPJ;EAUA;;IAEE,eAAA;EARF;EAUA;;IAEE,OAAA;EARF;EAUA;IACE,WCzHa;ID0Hb,WAAA;EARF;EAWE;IACE,OAAA;EATJ;EAYA;IACE,cAAA;EAVF;EAYA;IACE,qBAAA;EAVF;EAaA;IACE,wBAAA;EAXF;EAaA;IACE,yBAAA;EAXF;AACF;AAcA;EACE;;;IAGE,OAAA;EAZF;EAeA;IAEE,SAAA;IACA,gBAAA;EAdF;EAgBA;;IAGC,sBAAA;IACA,gBAAA;EAfD;EAkBA;IACE,aAAA;EAhBF;EAkBA;IACE,cAAA;EAhBF;EAkBA;IACE,sBAAA;IAEA,gBAAA;IAGA,UAAA;EAnBF;EAqBA;IAEE,MAAA;IACA,SAAA;IACA,cAAA;EApBF;EAsBA;IACE,gBAAA;EApBF;EAsBA;;IAEE,WAAA;EApBF;EAsBA;IACE,WAAA;EApBF;EAsBA;IACE,mBAAA;EApBF;AACF;AAsBA;EACE;IACE,YAAA;EApBF;EAsBA;IACE,aAAA;EApBF;AACF","sourcesContent":["@import './../assets/variables';\n\n.main-view {\n  position: fixed;\n  left: 440px;\n  top: 70px;\n  bottom: 50px;\n  // bottom: $footerHeight;\n  right: 0;\n  z-index: 0;\n  box-shadow: 0 0 5px rgba(black, 0.15);\n  border-top: 3px solid #ffffff;\n  border-radius: 10px;\n  width: 430px;\n  background-color: #fff;\n  // Monitoring unit panel only — do not apply to Users/Groups modals\n  .ScrollbarsCustom-Content:has(.monitoring-unit-panel) {\n    display: block !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n  &.no-sidebar {\n    top: $logoSectionHeight;\n    width: 51%;\n    left: 106px;\n    margin-top: 25px;\n  }\n}\n.montoringBoxes {\n  display:\"flex\"; \n  justify-content:\"center\"\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n.mb-0 {\n  margin-bottom: 0;\n}\n.ml-0 {\n  margin-left: 0;\n}\n.mr-0 {\n  margin-right: 0;\n}\n\n// .center-height {\n//   @media (min-width: 768px) {\n//     height: calc(100vh - #{$headerHeight} - #{$footerHeight} - 66px);\n//   }\n// }\n\n.navbar-menu-item .counter {\n  left: auto;\n  right: -0.3em;\n  top: -0.5em;\n}\n\n.no-sidebar {\n  left: $headerNavWidth;\n}\n.has-padding {\n  //overflow: auto;\n  padding: 12px;\n}\n\n.async-select {\n  color: #000;\n}\n.visible-responsive {\n  display: none !important;\n}\n\n.recharts-default-tooltip {\n  background: #fff;\n  color: #222;\n  min-width: 150px;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.full-height-container {\n  height: 100vh;\n  min-height: 100%;\n}\n.leaflet-container.chat-map-container {\n  height: 100%;\n  min-height: inherit;\n}\n.ticker__element {\n  .ticker-inner {\n    display: flex;\n    white-space: nowrap;\n    padding-left: 100px;\n  }\n}\n\n.MuiListSubheader-root {\n  line-height: 30px !important;\n  border-top: 1px solid;\n}\n\n// responsive\n\n@media (max-width: 959px) {\n  .header-open .main-view,\n  .no-sidebar .main-view,\n  .sidebar-collapse .main-view {\n    left: 0;\n  }\n  .fms-sidebar-wrapper,\n  .fms-sidebar-wrapper .fms-sidebar {\n    width: $sidebarWidthResponsive;\n    left: -$sidebarWidthResponsive;\n  }\n  .sidebar-dragicon {\n    display: none;\n  }\n  .sidebar-collapse .sidebar-dragicon {\n    display: block;\n  }\n  .sidebar-collapse {\n    .fms-sidebar-wrapper,\n    .fms-sidebar-wrapper .fms-sidebar {\n      left: 0;\n    }\n  }\n  .sidebar-devices-list,\n  .scrollable-sidebar {\n    margin-right: 0;\n  }\n  .fms-header,\n  .main-view {\n    left: 0;\n  }\n  .left-nav {\n    width: $headerNavWidth;\n    left: -$headerNavWidth;\n  }\n  .header-open {\n    .left-nav {\n      left: 0;\n    }\n  }\n  .navbar-menu .navbar-menu-item {\n    display: block;\n  }\n  .nav-link-text {\n    display: inline-block;\n  }\n\n  .hidden-responsive {\n    display: none !important;\n  }\n  .visible-responsive {\n    display: block !important;\n  }\n}\n\n@media (max-width: 888px) {\n  .header-open .main-view,\n  .no-sidebar .main-view,\n  .sidebar-collapse .main-view {\n    left: 0;\n\n  }\n  .fms-sidebar-wrapper {\n    // top: 0;\n    bottom: 0;\n    background: #fff;\n  }\n  .fms-sidebar-wrapper,\n  .fms-sidebar {\n  //  position: relative;\n   box-sizing: border-box;\n   background: #fff;\n  }\n\n  .sidebar-dragicon {\n    display: none;\n  }\n  .sidebar-collapse .sidebar-dragicon {\n    display: block;\n  }\n  .main-view {\n    box-sizing: border-box;\n    // position: absolute;\n    background: #fff;\n    // top: $logoSectionHeight;\n    // height: calc(100vh - #{$logoSectionHeight});\n    z-index: 0;\n  }\n  .main-view .main-view {\n    // position: absolute;\n    top: 0;\n    bottom: 0;\n    overflow: auto;\n  }\n  .daterangepicker .drp-selected {\n    padding-right: 0;\n  }\n  .daterangepicker .ranges,\n  .daterangepicker .drp-calendar {\n    float: none;\n  }\n  .daterangepicker .ranges ul {\n    width: auto;\n  }\n  .ScrollbarsCustom-Wrapper {\n    right: 0 !important;\n  }\n}\n@media (max-width: 499px) {\n  .main-view {\n    bottom: 28px;\n  }\n  .has-padding {\n    padding: 10px;\n  }\n}\n\n// @media (max-width:888px) {\n//   .main-view{\n//     width: 360px;\n//     left: 400px;\n//   }\n//   .fms-sidebar-wrapper{\n//     width: 290px;\n//   }\n// }\n// @media (max-width: 425px) {\n//   .main-view {\n//     width: 330px;\n//     left: 390px;\n//     margin-bottom: 20px; \n//   }\n//   .fms-sidebar-wrapper {\n//     width: 280px;\n//     position: relative;\n//     top: auto; \n//     left: 0;\n//     margin: 0 auto; \n//   }\n// }\n\n\n// .v-filter-field {\n//     border: 1px solid;\n//     display: block;\n//     width: 100%;\n//     padding: 4px 14px 1px;\n//     font-size: 12px;\n//     border-radius: 4px;\n//     box-sizing: border-box;\n//  }","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
